import React, { useState } from 'react';
import { checksDisney, collageDisney } from '../data/contenido';
import { civitatis, contacto } from '../data/viajes';
import useCivitatisResizer from '../hooks/useCivitatisResizer';
import { WA_DISNEY, WA_GENERAL } from '../services/whatsapp';
import { grande, micro, mini } from '../utils';
import './Tours.css';

export default function Tours() {
  const [tab, setTab] = useState('disney');
  useCivitatisResizer(tab === 'civitatis');

  return (
    <>
      <section className="tours-hero on-dark">
        <img className="tours-hero__bg" src={grande('images/disneyland-paris/disneyland-paris7.webp')} alt="" fetchpriority="high" decoding="async" />
        <div className="wrap tours-hero__in">
          <p className="eyebrow">Tours y experiencias</p>
          <h1 className="tours-hero__h1">Parques, aventuras y <em>experiencias</em> en todo el mundo</h1>
          <p className="tours-hero__lead">Paquetes Disney con asesoría completa de una agente certificada, y actividades en cada destino reservadas conmigo.</p>
          <div className="tours-tabs" role="tablist">
            <button role="tab" aria-selected={tab === 'disney'} className={tab === 'disney' ? 'is-on' : ''} onClick={() => setTab('disney')}><i className="fa-solid fa-wand-magic-sparkles" />Experiencias Disney</button>
            <button role="tab" aria-selected={tab === 'civitatis'} className={tab === 'civitatis' ? 'is-on' : ''} onClick={() => setTab('civitatis')}><i className="fa-solid fa-earth-americas" />Tours por el mundo</button>
          </div>
        </div>
      </section>

      <section className="tours sec">
        <div className="wrap">
          {tab === 'disney' ? (
            <div className="tours-disney">
              <div className="tours-collage" data-reveal>
                {collageDisney.map(({ src, cap, pos }) => <figure key={pos} className={`polaroid tours-collage__${pos}`}><img src={mini(src)} alt={cap} loading="lazy" decoding="async" /><figcaption>{cap}</figcaption></figure>)}
              </div>
              <div className="tours-disney__txt" data-reveal>
                <p className="eyebrow">Agente certificada Disney</p>
                <h2 className="h2">Planifica tu viaje Disney <em>con confianza</em></h2>
                <p className="lead">¿Estás pensando en visitar Walt Disney World, Disneyland California o hacer un crucero con Disney Cruise Line? En mi página oficial de Disney encontrarás:</p>
                <ul className="tours-checks">{checksDisney.map((c) => <li key={c}><i className="fa-solid fa-circle-check" />{c}</li>)}</ul>
                <div className="tours-deposito"><b>$200</b><span>USD es todo lo que necesitas para apartar tu paquete Disney. Después pagas poco a poco.</span></div>
                <div className="tours-ctas">
                  <a className="btn-dark" href={contacto.disney} target="_blank" rel="noopener noreferrer">Ver mi página oficial de Disney<i className="fa-solid fa-arrow-up-right-from-square" /></a>
                  <a className="btn-wa" href={WA_DISNEY} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" />Cotizar mi viaje Disney</a>
                </div>
              </div>
            </div>
          ) : (
            <div className="tours-civ">
              {civitatis.map((w) => (
                <article key={w.id} className="tours-civ__card">
                  <header>
                    <img src={micro(w.foto)} alt="" loading="lazy" decoding="async" />
                    <div><h3>{w.title}</h3><p>{w.description}</p></div>
                  </header>
                  <iframe data-civitatis="1" src={w.src} title={`Civitatis - ${w.title}`} loading="lazy" />
                </article>
              ))}
            </div>
          )}

          <div className="tours-final" data-reveal>
            <div>
              <h3>¿No encuentras lo que buscas?</h3>
              <p>Diseño tu viaje a la medida, a cualquier destino.</p>
            </div>
            <a className="btn-wa" href={WA_GENERAL} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" />Cuéntame tu idea</a>
          </div>
        </div>
      </section>
    </>
  );
}
